// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#057CFF","secondaryColor":"#4BA0FD","primaryText":"#333","regularText":"#3D3D4E"};